<template>
  <OnboardingModalContent title="" data-testid="congratulations-step">
    <div class="tw-flex tw-flex-col tw-items-center">
      <h1 class="tw-text-4xl tw-font-medium">
        {{ $t('onboarding_congratulations_title') }}
      </h1>
      <h2 class="tw-text-lg tw-font-medium">
        {{ $t('onboarding_congratulations_welcome_message') }}
      </h2>
      <div
        class="
          tw-flex
          tw-h-52
          tw-items-center
          tw-max-h-52
          tw-justify-center
          tw-overflow-hidden
        "
      >
        <youtube :fit-parent="true" width="100%" :video-id="videoId" />
      </div>
      <Button @click="onClick">{{ $t('onboarding_continue') }}</Button>
    </div>
    <template #bottom> </template>
  </OnboardingModalContent>
</template>

<script>
import OnboardingModalContent from './OnboardingModalContent'
import Button from '@/components/onboarding/Button'

export default {
  components: {
    Button,
    OnboardingModalContent,
  },
  props: {
    finishedOnboarding: {
      type: Function,
    },
  },
  data() {
    return { success: false }
  },
  computed: {
    videoId() {
      return this.$i18n.locale === 'es' ? 'cVBAG_lhTWw' : 'yRDAhwpYkao'
    },
  },
  methods: {
    async onClick() {
      await this.$axios.patch('/AUTH_URL/user', {
        onboarded: true,
      })
      this.$emit('closeModal')
      // this can't be done with an emit as the view is closed and the emit doesn't work after that.
      this.finishedOnboarding()
    },
  },
}
</script>

<style scoped></style>
